import { Theme, InputFieldSize, InputFieldShape } from './theme';

export function getInputFieldStyles(
	theme: Theme,
	size: InputFieldSize = 'default',
	shape: InputFieldShape = 'default'
) {
	const { width, height, padding, fontSize } = theme.input.size[size];
	const { borderRadius } = theme.input.shape[shape];
	const css = {
		input_css: {
			width: width,
			height: height,
			padding: padding,
			fontSize: fontSize,
			border: theme.input.inputBorder.border,
			borderRadius: borderRadius,
			boxShadow: theme.input.inputShadow,
			backgroundColor: theme.input.backgroundColor
		},
		inputLabel_css: {
			color: theme.inputLabel.color,
			outline: 'none'
		},
		inputHint_css: {
			color: theme.inputHint.color,
			fontSize: theme.inputHint.fontSize
		},
		inputHintError_css: {
			color: theme.inputHint.errorColor
		},
		inputFocused_css: {
			border: theme.input.focused.border,
			boxShadow: theme.input.focused.boxShadow
		},
		inputDisabled_css: {
			background: theme.input.disabled.background,
			color: theme.input.disabled.color
		},
		inputError_css: {
			border: theme.input.error.border
		},
		errorFocused_css: {
			boxShadow: theme.input.errorFocused.boxShadow
		},
		pillCss: {
			borderRadius: theme.input.shape.pill.borderRadius
		},
		icons: {
			loading: theme.iconColors.loading,
			error: theme.iconColors.error,
			tooltip: theme.iconColors.tooltip
		}
	};

	return css;
}
